module.exports = __webpack_public_path__ + "static/media/cancle.f84d11e8.svg";